import { and } from 'tio-ui/utilities';
import { hash } from '@ember/helper';
import { htmlSafe } from '@ember/template';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type IntlService from 'ember-intl/services/intl';
import { PhWarning } from 'ember-phosphor-icons';

export interface ErrorSignature {
  detail: string;
}

export type ErrorsSignature = {
  errors: ErrorSignature[];
};

interface TioErrorMessagesSignature {
  Args: {
    error?: string | ErrorsSignature | null;
    icon?: string;
    iconClass?: string;
    listClass?: string;
    showErrors: boolean;
  };
  Blocks: {
    default: [unknown];
  };
  Element: HTMLDivElement;
}

export default class TioErrorMessagesComponent extends Component<TioErrorMessagesSignature> {
  @service declare intl: IntlService;

  // TODO: This is very rudimentary but eventually could be expanded to parse
  // more helpful error messages based on error code, etc.
  get parsedErrorMessages() {
    const genericErrorMessage = this.intl.t('common.unknown_error_occurred');
    const error = this.args.error;
    if (typeof error === 'string') {
      return [error];
    } else if (error?.errors) {
      return error.errors.map((err) => {
        if (err?.detail === '[object Object]') {
          return genericErrorMessage;
        }
        return err?.detail || genericErrorMessage;
      });
    } else if (error) {
      return [genericErrorMessage];
    }
    return [];
  }

  <template>
    {{#if (and @showErrors @error)}}
      {{#if (has-block)}}
        {{yield (hash errorMessages=this.parsedErrorMessages)}}
      {{else}}
        <div class="text-red-600 p-2 {{if @icon 'flex gap-2 items-start'}}" ...attributes>
          {{#if @icon}}
            <PhWarning @size="20" @weight="fill" class="flex-none text-red-600 {{@iconClass}}" />
          {{/if}}
          <ul class={{@listClass}}>
            {{#each this.parsedErrorMessages as |message|}}
              <li class="whitespace-normal">{{htmlSafe message}}</li>
            {{/each}}
          </ul>
        </div>
      {{/if}}
    {{/if}}
  </template>
}
